import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import RectangularTabs from '../../widgets/components/RectangularTabs'
import GeneralSettings from '../components/SettingsAndPolicies/GeneralSettings'
import Policies from '../components/SettingsAndPolicies/Policies'
import NotificationsGeneral from '../components/SettingsAndPolicies/NotificationsGeneral'
import { PageTitle } from '../../../../_metronic/layout/core'
import { RecordsKeeperAIBreadCrumbs } from '../core/_constants'

const SettingsAndPolicies = () => {

    const { formatMessage } = useIntl()

    const options = [
        {
            id: 1,
            slug: 'Access-Logs',
            title: formatMessage({ id: 'General' }),
            subTitle: formatMessage({ id: 'General Settings' }),
        },
        {
            id: 2,
            slug: 'Activity-Logs',
            title: formatMessage({ id: 'Policies' }),
            subTitle: formatMessage({ id: 'Policy Settings' }),
        },
        {
            id: 3,
            slug: 'Activity-Logs',
            title: formatMessage({ id: 'Notifications' }),
            subTitle: formatMessage({ id: 'Notification Settings' }),
        },
    ]

    const [selectedTab, setSelectedTab] = useState<number>(1)

    const handleTabChange = (id: number) => {
        setSelectedTab(id)
    }

    return (
        <div>
            <div>
                <PageTitle
                    breadcrumbs={RecordsKeeperAIBreadCrumbs}
                    description={formatMessage({ id: 'Settings & Policies' })}
                >
                    {formatMessage({ id: 'RecordsKeeper AI' })}
                </PageTitle>
            </div>
            <div className='px-6'>
                <RectangularTabs
                    options={options}
                    selectedTab={selectedTab}
                    handleTabChange={handleTabChange}
                />

                <div className='my-auto w-100 mt-4 mt-md-4'>
                    {selectedTab === 1 &&
                        <GeneralSettings />
                    }
                    {selectedTab === 2 &&
                        <Policies />
                    }
                    {selectedTab === 3 &&
                        <NotificationsGeneral />
                    }
                </div>
            </div>
        </div>
    )
}

export default SettingsAndPolicies
